export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
  <path fill="currentcolor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 1.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17Zm2.41 4.97a.75.75 0 0 1 1.06 1.06l-2.41 2.41 2.542 2.54a.75.75 0 0 1-1.062 1.061L11.999 13l-2.54 2.541a.75.75 0 0 1-1.06-1.06l2.54-2.541L8.53 9.53a.75.75 0 0 1 1.06-1.06L12 10.879l2.41-2.41Z"/>
</svg>
`;
